import { isEmpty, map } from 'lodash';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FormikSelect } from 'components';
import { PAYOUT_REJECT_SELECT_DETAILS } from 'constants/order.constants';
import { PayoutRejectStatusDetails } from 'enums';
import { TranslationNamespace } from 'i18n';
import { orderUtils } from 'utils';

type Props = {
  name?: string;
  statusDetailsList?: PayoutRejectStatusDetails[];
};

export const RejectSelect: React.FC<Props> = ({
  name = 'statusDetails',
  statusDetailsList,
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders',
  });

  const detailsList = useMemo(
    () =>
      isEmpty(statusDetailsList)
        ? PAYOUT_REJECT_SELECT_DETAILS
        : statusDetailsList,
    [statusDetailsList],
  );

  const options = useMemo(
    () =>
      map(detailsList, (value) => ({
        value,
        label: orderUtils.getPayoutStatusDetailsLabel(value),
      })),
    [detailsList],
  );

  return (
    <FormikSelect
      label={t('resolve.reason')}
      name={name}
      noneOption={false}
      options={options}
      fullWidth
      size="small"
    />
  );
};
